import { Translate } from "components/common/Translate/Translate";
import type { SelectedColor as SelectedColorType } from "store/features/colorPicker/types";

interface SelectedColorProps {
    selectedColor: SelectedColorType;
}

export const SelectedColor = ({ selectedColor }: SelectedColorProps) => {
    return (
        <div className="flex items-center w-full gap-2">
            <div className="flex flex-col gap-4 w-full">
                <div className="capitalize font-semibold text-lg" data-testid={`selected-color-label`}>
                    <Translate keyName="selected-color" />
                </div>
                <div className="flex flex-col gap-4">
                    <div
                        className="relative py-7 w-full rounded-lg transition-colors duration-75 ease-in-out overflow-hidden"
                        style={{ backgroundImage: `url("/checked-bg.png")` }}
                        data-testid={`selected-color-preview`}
                    >
                        <div className="absolute inset-0" style={{ backgroundColor: `${selectedColor.rgb}` }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};
